import { render } from "./AposGridColumn.vue?vue&type=template&id=0b64f0e1"
import script from "./AposGridColumn.vue?vue&type=script&setup=true&lang=js"
export * from "./AposGridColumn.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"layout-widget/ui/apos/components/AposGridColumn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b64f0e1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b64f0e1', __exports__)) {
    api.reload('0b64f0e1', __exports__)
  }
  
  module.hot.accept("./AposGridColumn.vue?vue&type=template&id=0b64f0e1", () => {
    api.rerender('0b64f0e1', render)
  })

}


export default __exports__